export enum ActivityStreamEvaluationMemberPropertyType {
  NewJobCodeId = 'NewJobCodeId',
  NewPositionClass = 'NewPositionClass',
  CountryIsoCode = 'CountryIsoCode',
  PlacementState = 'PlacementState',
  ValidationState = 'ValidationState',
  ValidationManagerId = 'ValidationManagerId'
}
